import { usePlatformStats } from '@/hooks/use-platform-stats';
import { publicLanguages } from '@/lib/language-name';

export type AuthShellFigures =
  | { status: 'loading' }
  | { status: 'unavailable' }
  | { status: 'ready'; recordings: number; validated: number; contributors: number; languages: number };

const count = (value: unknown): number | null =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.round(value) : null;

/**
 * Reads the real figures of /stats/platform, without inventing any. A partial
 * or malformed payload counts as unavailable: better no figure than a fake 0.
 */
export function useAuthShellFigures(): AuthShellFigures {
  const { data, isLoading } = usePlatformStats();
  if (data) {
    const recordings = count(data.audio?.total);
    const validated = count(data.audio?.accepted);
    const contributors = count(data.contributors?.total);
    // Same list as the home page: clean names, no duplicates, no test entries.
    const languages = Array.isArray(data.languages?.byLanguage) ? publicLanguages(data.languages.byLanguage).length : null;
    if (recordings !== null && validated !== null && contributors !== null && languages !== null) {
      return { status: 'ready', recordings, validated, contributors, languages };
    }
    return { status: 'unavailable' };
  }
  return isLoading ? { status: 'loading' } : { status: 'unavailable' };
}
